import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import isEmpty from 'ramda/src/isEmpty';
import slice from 'ramda/src/slice';
import Button from '@components/@core/AnimatedButton';
import Pagination from '@components/@core/Pagination';
import CompanyActions from '~/actions/company';
import EmptyProduct from './EmptyProduct';
import ProductItem from './ProductItem';

const VendorSearchProducts = ({ data, type, onPage, onSeeAll }) => {
    const dispatch = useDispatch();
    const productList = data?.data ?? [];
    const products = type === 'sub' ? slice(0, 3, productList) : productList;

    const handleOpenDetail = (e) => () => {
        window.location = `/${e.company.slug}/${e.slug}`;
        {
            /*
    const { company, data } = e
    const payload = { id: company?.business_id }
    const route = {
      pathname: `/business/${e.slug}`,
      search: `?id=${e?.business_id}&category=${e?.category?.id}`,
    }
    dispatch(CompanyActions.getbusinessRequest(payload, route))
    */
        }
    };

    return (
        <div className="vendor-search-products">
            <div className="d-h-start">
                <p className="dsl-b18 bold me-2">Products</p>
                <p className="dsl-p12">{`(${data?.total ?? productList.length})`}</p>
            </div>
            {isEmpty(products) ? (
                <EmptyProduct />
            ) : (
                <div className="border-bottom pb-3 mb-5">
                    {products.map((product) => {
                        const { id, avatar, name, data, stats } = product;
                        const { contact, description } = data;
                        return (
                            <ProductItem
                                key={`product-${id}`}
                                logo={avatar}
                                name={name}
                                description={description}
                                recommend={stats?.rating_recommended_avg || ''}
                                rating={Number(stats?.rating_avg || 0)}
                                ratingCount={stats?.rating_count || ''}
                                phone={contact?.phone}
                                onClick={handleOpenDetail(product)}
                                isSponsored={data.sponsored_level === 'gold' || data.sponsored_level === 'silver'}
                            />
                        );
                    })}
                    {type === 'sub' ? (
                        <div className="d-h-end">
                            <Button type="link" name="SEE ALL" onClick={onSeeAll} />
                        </div>
                    ) : (
                        type !== 'sub' && data?.total > 25 && <Pagination current={data?.page ?? 1} pers={[]} total={data?.total ?? 0} onChange={onPage} />
                    )}
                </div>
            )}
        </div>
    );
};

VendorSearchProducts.propTypes = {
    data: PropTypes.shape({
        data: PropTypes.array,
    }),
    type: PropTypes.oneOf(['sub', 'full']),
    onSeeAll: PropTypes.func,
    onPage: PropTypes.func,
};

VendorSearchProducts.defaultProps = {
    data: { data: [] },
    type: 'sub',
    onSeeAll: () => {},
    onPage: () => {},
};

export default memo(VendorSearchProducts);
